import { config } from '../config';

export const DEFAULT_FONDO_OPACIDAD = 78;

export const FUENTES_INTERFAZ = {
  inter: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  },
  poppins: {
    family: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  },
  nunito: {
    family: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  },
  'roboto-slab': {
    family: "'Roboto Slab', Georgia, serif",
    display: "'Roboto Slab', Georgia, serif"
  },
  merriweather: {
    family: "'Merriweather', Georgia, serif",
    display: "'Merriweather', Georgia, serif"
  },
  'coming-soon': {
    family: "'Coming Soon', cursive",
    display: "'Coming Soon', cursive"
  },
  system: {
    family: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  }
};

export function applyAppFuente(fuenteInterfaz) {
  const key = FUENTES_INTERFAZ[fuenteInterfaz] ? fuenteInterfaz : 'inter';
  const fuente = FUENTES_INTERFAZ[key];
  document.documentElement.style.setProperty('--homes-font-family', fuente.family);
  document.documentElement.style.setProperty('--homes-font-family-display', fuente.display);
}


export function fondoOpacidadToAlpha(opacidad) {
  const v = opacidad ?? DEFAULT_FONDO_OPACIDAD;
  return Math.min(100, Math.max(0, Number(v))) / 100;
}

/** Aplica fondo y velado al contenedor principal (.App). */
export function applyAppFondo({ fondoPersonalizado, fondoOpacidad, updatedAt }) {
  const appEl = document.querySelector('.App');
  const alpha = fondoOpacidadToAlpha(fondoOpacidad);

  if (!appEl) {
    console.warn('[HOMES:Fondo] No se encontró .App', {
      fondoPersonalizado,
      fondoOpacidad,
      updatedAt
    });
    return;
  }

  if (!fondoPersonalizado) {
    appEl.style.removeProperty('--app-fondo-url');
    appEl.style.removeProperty('--app-fondo-overlay-alpha');
    appEl.classList.remove('app-with-custom-fondo');
    console.info('[HOMES:Fondo] Fondo predeterminado aplicado', {
      motivo: 'sin fondo personalizado'
    });
    return;
  }

  const cacheBust = updatedAt ? new Date(updatedAt).getTime() : Date.now();
  const url = `${config.uploadsUrl}/${fondoPersonalizado}?v=${cacheBust}`;
  appEl.style.setProperty('--app-fondo-url', `url("${url}")`);
  appEl.style.setProperty('--app-fondo-overlay-alpha', String(alpha));
  appEl.classList.add('app-with-custom-fondo');

  const computed = window.getComputedStyle(appEl);
  console.info('[HOMES:Fondo] Fondo aplicado', {
    url,
    fondoOpacidad,
    alpha,
    tieneClase: appEl.classList.contains('app-with-custom-fondo'),
    variableUrl: appEl.style.getPropertyValue('--app-fondo-url'),
    backgroundImage: computed.backgroundImage,
    viewport: `${window.innerWidth}x${window.innerHeight}`
  });

  const imagen = new Image();
  imagen.onload = () => console.info('[HOMES:Fondo] Imagen cargada', {
    url,
    width: imagen.naturalWidth,
    height: imagen.naturalHeight
  });
  imagen.onerror = () => console.error('[HOMES:Fondo] Error cargando imagen', { url });
  imagen.src = url;
}
